<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18px"
    height="18px"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m17 13l-5 5m0 0l-5-5m5 5V6"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "ArrowDownIcon",
};
</script>
